import axios from 'axios';

/**
 * Formas de pago que de verdad ofrece la página de cobro. Las decide el
 * backend (/api/payment/methods) con la misma lógica que arma la sesión de
 * Stripe, así que nunca se anuncia un método que el cliente no va a ver.
 * Mientras no hay respuesta (o si falla) se asume solo tarjeta: es lo único
 * que siempre está disponible.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const KNOWN = ['card', 'oxxo', 'spei'];
let pending = null;

export function normalizeMethods(list) {
    const out = (Array.isArray(list) ? list : []).filter((m) => KNOWN.includes(m));
    return out.includes('card') ? out : ['card', ...out];
}

export function fetchPaymentMethods() {
    if (!pending) {
        pending = axios
            .get(`${BACKEND_URL}/api/payment/methods`, { timeout: 6000 })
            .then((r) => normalizeMethods(r.data?.methods))
            .catch(() => {
                pending = null;   // se reintenta en la siguiente página
                return ['card'];
            });
    }
    return pending;
}

/** "tarjeta, efectivo en OXXO o transferencia SPEI" */
export function paymentMethodsSentence(methods) {
    const parts = ['tarjeta (crédito o débito)'];
    if (methods.includes('oxxo')) parts.push('efectivo en OXXO');
    if (methods.includes('spei')) parts.push('transferencia SPEI');
    if (parts.length === 1) return parts[0];
    return `${parts.slice(0, -1).join(', ')} o ${parts[parts.length - 1]}`;
}
